module.exports = __webpack_public_path__ + "static/assets/a00bdab883cdd809b65d4cab21077687.svg";